(function () {
  if (window.__nestCartModalStability20260703) return;
  window.__nestCartModalStability20260703 = true;

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var overlaySelector = '.seo-cart-page-overlay';
  var cartSelector = '.cart-modal, #CartDrawer, .cart-drawer, .drawer--cart, .ajax-cart, [data-cart-drawer], [data-cart-container]';
  var closeSelector = '#cart-close-icon, [data-cart-close], .cart-close-icon, .cart-popup__close, button[aria-label*="Close"], button[aria-label*="close"]';
  var cartIconSelector = '.site-header__cart, a[href="/cart"], a[href$="/cart"], a[href*="/cart?"] , [data-cart-toggle], [data-cart-trigger], [data-cart-icon], button[aria-label*="cart" i], a[aria-label*="cart" i]';
  var addToCartSelector = '[data-add-to-cart], button[name="add"], input[name="add"], .product-form__cart-submit, form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"]';
  var extendSelector = '#extend-offers-modal-iframe, #extend-learn-more-modal-iframe, iframe[id*="extend"][id*="modal"], iframe[src*="extend.com"], iframe[src*="helloextend"], [id*="extend" i][role="dialog"], [class*="extend" i][role="dialog"], [class*="extend" i][class*="modal" i]';
  var manualCartOpenUntil = 0;
  var syncTimer = null;
  var pollTimer = null;

  function installStyle() {
    if (document.getElementById('nest-cart-modal-stability-20260703')) return;
    var style = document.createElement('style');
    style.id = 'nest-cart-modal-stability-20260703';
    style.textContent = [
      '@media only screen and (min-width: 990px) {',
      '  body.seo-cart-overlay-active .seo-cart-page-overlay {',
      '    display: block !important;',
      '    opacity: 1 !important;',
      '    pointer-events: auto !important;',
      '    z-index: 99998 !important;',
      '  }',
      '  body.seo-cart-overlay-active .cart-modal {',
      '    z-index: 99999 !important;',
      '  }',
      '}',
      '@media only screen and (max-width: 749px) {',
      '  body.nest-cart-modal-open.nest-cart-opened-from-header .cart-modal {',
      '    position: fixed !important;',
      '    top: var(--nest-mobile-cart-top, 0px) !important;',
      '    height: calc(100dvh - var(--nest-mobile-cart-top, 0px)) !important;',
      '    max-height: calc(100dvh - var(--nest-mobile-cart-top, 0px)) !important;',
      '    padding-top: max(20px, calc(env(safe-area-inset-top, 0px) + 12px)) !important;',
      '    overflow-y: auto !important;',
      '    -webkit-overflow-scrolling: touch !important;',
      '    box-sizing: border-box !important;',
      '    z-index: 99999 !important;',
      '  }',
      '  body.nest-cart-modal-open.nest-cart-opened-from-header .cart-modal #cart-close-icon,',
      '  body.nest-cart-modal-open.nest-cart-opened-from-header .cart-modal .cart-close-icon,',
      '  body.nest-cart-modal-open.nest-cart-opened-from-header .cart-modal [data-cart-close],',
      '  body.nest-cart-modal-open.nest-cart-opened-from-header .cart-modal .cart-popup__close {',
      '    position: relative !important;',
      '    z-index: 100000 !important;',
      '  }',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  }

  function visible(element) {
    if (!element || !document.documentElement.contains(element)) return false;
    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 0 && rect.height > 0;
  }

  function cartModal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(cartSelector));
    return nodes.find(function (node) {
      return visible(node) || node.style.display === 'block' || /open|active|visible/i.test(node.className || '');
    }) || document.querySelector(cartSelector);
  }

  function cartOpen() {
    var modal = cartModal();
    return !!(modal && (visible(modal) || modal.style.display === 'block' || /open|active|visible/i.test(modal.className || '')));
  }

  function extendOpen() {
    return Array.prototype.some.call(document.querySelectorAll(extendSelector), visible);
  }

  function extendHoldActive() {
    return document.documentElement.classList.contains('nest-extend-cart-drawer-hold-active') || document.body.classList.contains('seo-cart-extend-pending');
  }

  function getOverlay() {
    var overlay = document.querySelector(overlaySelector);
    if (overlay) return overlay;
    overlay = document.createElement('button');
    overlay.type = 'button';
    overlay.className = 'seo-cart-page-overlay';
    overlay.setAttribute('aria-label', 'Close cart');
    overlay.setAttribute('data-seo-cart-overlay', '');
    overlay.addEventListener('click', function (event) {
      event.preventDefault();
      closeCart();
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function closeCart() {
    var modal = cartModal();
    if (!modal) return;
    var close = modal.querySelector(closeSelector);
    if (close && typeof close.click === 'function') close.click();
    else modal.style.display = 'none';
    manualCartOpenUntil = 0;
    scheduleSync(40);
  }

  function mobileHeaderOffset() {
    if (!mobileQuery.matches) return 0;
    var selectors = ['#shopify-section-header', '.site-header', '.site-header__mobile-nav', 'header[role="banner"]'];
    var best = 0;
    selectors.forEach(function (selector) {
      var node = document.querySelector(selector);
      if (!visible(node)) return;
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      var anchored = style.position === 'fixed' || style.position === 'sticky' || rect.top <= 1;
      if (!anchored || rect.height > 180) return;
      best = Math.max(best, Math.min(140, Math.round(rect.bottom)));
    });
    return Math.max(0, best);
  }

  function syncDesktopOverlay(open) {
    if (!desktopQuery.matches) {
      document.body.classList.remove('seo-cart-overlay-active');
      return;
    }
    if (open && !extendOpen() && !extendHoldActive()) {
      getOverlay();
      document.body.classList.add('seo-cart-overlay-active');
      return;
    }
    if (!open) document.body.classList.remove('seo-cart-overlay-active');
  }

  function syncMobileCart(open) {
    if (!mobileQuery.matches) {
      document.body.classList.remove('nest-cart-modal-open', 'nest-cart-opened-from-header');
      document.documentElement.style.removeProperty('--nest-mobile-cart-top');
      return;
    }

    document.body.classList.toggle('nest-cart-modal-open', open);
    if (!open) {
      document.body.classList.remove('nest-cart-opened-from-header');
      document.documentElement.style.removeProperty('--nest-mobile-cart-top');
      return;
    }

    if (Date.now() <= manualCartOpenUntil || document.body.classList.contains('nest-cart-opened-from-header')) {
      document.body.classList.add('nest-cart-opened-from-header');
      document.documentElement.style.setProperty('--nest-mobile-cart-top', mobileHeaderOffset() + 'px');
    }
  }

  function sync() {
    var open = cartOpen();
    syncDesktopOverlay(open);
    syncMobileCart(open);
    setPolling(open || extendOpen() || extendHoldActive());
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, typeof delay === 'number' ? delay : 0);
  }

  function burst() {
    [0, 50, 120, 250, 500, 900, 1500, 2500].forEach(function (delay) {
      window.setTimeout(sync, delay);
    });
  }

  function setPolling(active) {
    if (active && !pollTimer) pollTimer = window.setInterval(sync, 200);
    if (!active && pollTimer) {
      window.clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function noteManualCartOpen(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest(addToCartSelector)) return;
    if (!target.closest(cartIconSelector)) return;
    manualCartOpenUntil = Date.now() + 5000;
    burst();
  }

  function init() {
    installStyle();
    getOverlay();
    document.addEventListener('pointerdown', noteManualCartOpen, true);
    document.addEventListener('touchstart', noteManualCartOpen, true);
    document.addEventListener('mousedown', noteManualCartOpen, true);
    document.addEventListener('click', function () { burst(); }, true);
    document.addEventListener('submit', burst, true);
    ['cart:refresh', 'refreshCart', 'refreshAjaxCart'].forEach(function (eventName) {
      window.addEventListener(eventName, burst);
    });
    window.addEventListener('resize', burst);
    window.addEventListener('orientationchange', burst);
    window.addEventListener('scroll', function () { scheduleSync(40); }, true);
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', burst);
    else if (desktopQuery.addListener) desktopQuery.addListener(burst);
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', burst);
    else if (mobileQuery.addListener) mobileQuery.addListener(burst);
    if (window.MutationObserver) {
      new MutationObserver(function () { scheduleSync(30); }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
      });
    }
    burst();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
